import axios from "axios";
import { FILE_UPLOAD } from "../../../config/realstar-api-config";

export const uploadFile = async (formData , userEncryptedID) => {
  let userid = userEncryptedID;
  
  if(!userid){
    userid = process.env.REACT_APP_REALSTAR_SYSADMIN_ID
  }
  
  try {
    const url = `${FILE_UPLOAD}${userid}`; 

    const response = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    console.log("File Uploaded")
    return response.data.path

  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};
